<div class="client-view">
    <ng-container [dynamic]="view()"></ng-container>
</div>
